export const fmsFormLinkOptions = [
  {
    label: 'Service FMS',
    sheetName: 'Service FMS',
    purpose: 'Service FMS',
    value: 'https://docs.google.com/forms/d/e/1FAIpQLSepmNI6YLqY2NDe6H86LD3oY3JC9AKPwCjcJ37gOKdj0ie4tA/viewform'
  },
  {
    label: 'Feedback FMS',
    sheetName: 'Feedback FMS',
    purpose: 'Feedback FMS',
    value: 'https://docs.google.com/forms/d/e/1FAIpQLSd8lt-G--uDdj3K6JvhaXYxdIDtuKeicQsMHR8bVYNl6KL17Q/viewform'
  },
  {
    label: 'Client Follow-up FMS',
    sheetName: 'Client Follow-up FMS',
    purpose: 'Client Follow-up FMS',
    value: 'https://docs.google.com/forms/d/e/1FAIpQLSfq0qd7WJzpj0MJf5C6mzTyPB1SZMGM1FFtjef_Nx37HpsJzw/viewform'
  },
  {
    label: 'Campaign / Social FMS',
    sheetName: 'Campaign / Social FMS',
    purpose: 'Campaign / Social FMS',
    value: 'https://docs.google.com/forms/d/e/1FAIpQLSeEkyaN67ilbBSEJh-tyBTsxreAq9OSuWf-DCSFANSL8Xv85A/viewform'
  }
];
